const __WEBPACK_NAMESPACE_OBJECT__ = require("read-pkg");;